import { useTheme } from '@mui/styles';

import {
  CELL_HEIGHT,
  CELL_SPACING,
  CELL_WIDTH,
  CUSTOM_PADDING,
  LEFT_COLUMN,
} from '../../../../../../constants';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    rowWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
      marginBottom: `${CELL_SPACING}px`,
    },
    nameCell: {
      width: `${LEFT_COLUMN}px`,
      flexShrink: 0,
      display: 'flex',
    },
    userName: {
      textDecoration: 'none',
      color: 'black',
      padding: `${CUSTOM_PADDING}px`,
    },
    avatar: {
      width: `${CELL_WIDTH}px`,
      height: `${CELL_HEIGHT}px`,
      display: 'inline-block',
      marginRight: `${CELL_SPACING * 3}px`,
    },
    nameSpan: {
      justifyContent: 'center',
    },
    minNameCell: {
      width: '50px',
      flexShrink: 0,
      display: 'flex',
      paddingRight: theme.spacing(1),
      overflow: 'hidden',
    },
  };
};
